import { Component, ElementRef, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuctionService } from '../../../../services/AuctionService';
import { Property } from '../../../../models/property';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs';

declare let Plaid: any;

@Component({ standalone: false,
  selector: 'authorization-dialog-plaid',
  templateUrl: 'authorization-dialog-plaid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['authorization-dialog-plaid.component.scss']
})
export class AuthorizationDialogPlaidComponent {
  @ViewChild('paymentRef', {static:true}) paymentRef!:ElementRef;
  @ViewChild('cardForm', {static:true}) cardForm!:ElementRef;
  @ViewChild('cardNameContainer ', {static:true}) cardNameContainer !:ElementRef;
  @ViewChild('cardNumberContainer', {static:true}) cardNumberContainer!:ElementRef;
  @ViewChild('cardExpiryContainer', {static:true}) cardExpiryContainer!:ElementRef;
  @ViewChild('cardCvvContainer', {static:true}) cardCvvContainer!:ElementRef;

  public title: string= "ACH Authorization";
  public confirmButtonText = "Authorize";
  public cancelButtonText = "Cancel";

  public busy:boolean=false;
  public paymentIntentId!:string;
  public plaidError?: string;
  public plaidMessage?: string;

  public property!:Property;
  private plaidLinkHandler:any

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<AuthorizationDialogPlaidComponent>, private auctionService:AuctionService, private snackBar: MatSnackBar) {
    if(data){
      this.property=data.property;
      this.paymentIntentId=data.paymentIntentId?data.paymentIntentId:undefined;
    }
  }

  ngOnInit(){
    //first we need to check if the user has his bank accounts already linked via plaid => check with server
    //if not linked yet, we need to start the link scrip and process first
    //if linked we can directly verify account balances
    //TODO: check if already linked
    //START LINK SCRIPT AND PROCESS
    this.auctionService.getPlaidLinkToken().pipe(take(1)).subscribe(r=>{
      const linkToken = r.linkToken;
      if(!linkToken) return; // token request failed - error already handled by the API service
      setTimeout(() => {
        let id = "plaidLinkScript";
        if(document.getElementById(id) === null) {
          this.addPlaidScript(id).then(()=> {
            this.createPlaidLink(linkToken);
          });
        }
        else{
          this.createPlaidLink(linkToken);
        }
      }, 1);
    });
  }

  ngOnDestroy(){
    if(this.plaidLinkHandler) this.plaidLinkHandler.destroy();
  }

  //#region link process
  private addPlaidScript(id: string): any {
    return new Promise((resolve,reject)=>{
      if(document.getElementById(id) === null){
        let scriptTagElement = document.createElement('script');
        scriptTagElement.src = "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
        scriptTagElement.id = id;
        scriptTagElement.onload = resolve;
        document.body.appendChild(scriptTagElement);
      }
    });
  }
  private createPlaidLink(token:string){
    this.plaidLinkHandler = Plaid.create({
  
      token: token,
    
      onSuccess: (public_token:any, metadata:any) => { this.exchangePublicToken(public_token)},
    
      onLoad: () => { console.log("onLoad");},
    
      onExit: (err:any, metadata:any) => {console.log("onExit")},
    
      onEvent: (eventName:any, metadata:any) => {console.log("onEvent")},
    
    });
    this.plaidLinkHandler.open();
  }
  private exchangePublicToken(publicToken:string){
    this.plaidMessage=undefined;
    this.plaidError=undefined;
    this.busy=true;
    this.auctionService.exchangePublicToken(publicToken).pipe(take(1)).subscribe(r=>{
      if(r.success){
        //public token has been exchanged for an access token => now we can check account balances
        this.plaidMessage="Account successfully linked. Verifying balances..."
        this.auctionService.authorizeForAuctionPlaid(this.property.auction!.id, this.property.auction!.scheduleSeqNo!, this.amountToAuthorize, true).pipe(take(1)).subscribe(r=>{
          if(r.success){
            this.snackBar.open('Authorization successful.', '×', { panelClass: ['primary-snackbar'], verticalPosition: 'top', duration: 3000 });
            this.dialogRef.close(false);
          }
          else{
            this.plaidMessage=undefined;
            this.plaidError=r.message;
          }
          this.busy=false;
        });
      }
      else{
        this.plaidError="Unable to obtain access token.";
        this.busy=false;
      }
    });
  }
  //#endregion

  get amountToAuthorize(){
    return this.property.auction!.amountToAuthorize!;
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onOKClick(): void {
    this.dialogRef.close(false);
  }

}



